import styled from "styled-components";
import type { EmbeddedStyledProps } from "../types";

export const EmbeddedStyled = styled.div<EmbeddedStyledProps>`
  justify-content: ${({ $horizontalAlignment }) => $horizontalAlignment};
  .embedded-CNicd88eelKe801--wrapper {
    width: var(--entity-size);
    height: var(--entity-height);
  }
  .placeholder,
  .empty,
  .embedded-CNicd88eelKe801--wrapper {
    border-radius: ${({ $round }) => $round};
  }
`;
